import { graphql, useStaticQuery } from 'gatsby'

export function useGithubFpjs() {
  try {
    const data = useStaticQuery(graphql`
      query {
        github {
          repository(owner: "fingerprintjs", name: "fingerprintjs") {
            stargazerCount
          }
        }
      }
    `)

    return {
      githubData: {
        stargazers_count: data?.github?.repository?.stargazerCount ?? 0,
      },
    }
  } catch (error) {
    return {
      githubData: {
        stargazers_count: 0,
      },
    }
  }
}
